var map = {
	"./Color-picker.svg": "./src/icons/Color-picker.svg",
	"./Date-time.svg": "./src/icons/Date-time.svg",
	"./Date.svg": "./src/icons/Date.svg",
	"./Html.svg": "./src/icons/Html.svg",
	"./ImageGroup.svg": "./src/icons/ImageGroup.svg",
	"./Multi-select.svg": "./src/icons/Multi-select.svg",
	"./Number.svg": "./src/icons/Number.svg",
	"./Time.svg": "./src/icons/Time.svg",
	"./action_copy.svg": "./src/icons/action_copy.svg",
	"./action_remove.svg": "./src/icons/action_remove.svg",
	"./checkbox.svg": "./src/icons/checkbox.svg",
	"./checkgroup.svg": "./src/icons/checkgroup.svg",
	"./cllogic.svg": "./src/icons/cllogic.svg",
	"./cllogic111.svg": "./src/icons/cllogic111.svg",
	"./color-group.svg": "./src/icons/color-group.svg",
	"./colorPicker.svg": "./src/icons/colorPicker.svg",
	"./copy.svg": "./src/icons/copy.svg",
	"./delete.svg": "./src/icons/delete.svg",
	"./edit.svg": "./src/icons/edit.svg",
	"./file-text.svg": "./src/icons/file-text.svg",
	"./header.svg": "./src/icons/header.svg",
	"./map-pin.svg": "./src/icons/map-pin.svg",
	"./month.svg": "./src/icons/month.svg",
	"./paragraph.svg": "./src/icons/paragraph.svg",
	"./pricing.svg": "./src/icons/pricing.svg",
	"./radio.svg": "./src/icons/radio.svg",
	"./select.svg": "./src/icons/select.svg",
	"./settings.svg": "./src/icons/settings.svg",
	"./sliders.svg": "./src/icons/sliders.svg",
	"./switch.svg": "./src/icons/switch.svg",
	"./text.svg": "./src/icons/text.svg",
	"./textarea.svg": "./src/icons/textarea.svg",
	"./textbox.svg": "./src/icons/textbox.svg",
	"./trash.svg": "./src/icons/trash.svg",
	"./upload.svg": "./src/icons/upload.svg",
	"./url.svg": "./src/icons/url.svg",
	"./week.svg": "./src/icons/week.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons sync recursive ^\\.\\/.*$";